import {
  Box,
  Button,
  Card,
  Dialog,
  Grid,
  Stack,
  Typography,
  useMediaQuery,
} from '@mui/material';
import { Moxoseparationinlisting, postApiCall } from 'api/apiService';
import {
  counterLiveDTag,
  liveDTag,
} from 'component/LiveOfferStatus/LiveOfferStatus.style';
import { getDashboardActivity } from 'constant/app.config';
import moment from 'moment';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';
import {
  fontsize32,
  poppins400,
  poppins500,
  poppins600,
} from 'theme/common.style';
import { counterAlignColumProp } from './CountDownTimer.style';
import { UseCountdown } from './UseCountdown';
// import { Colon } from "component/BuyersMarketplace/Market";
import { keyframes, useTheme } from '@emotion/react';
import Auction from 'modules/private/Auction/Auction';
import { toast } from 'react-toastify';
import AuctionDialogOne from './Auctiondialogone';
import AuctionDialogTwo from './Auctiondialogtwo';
const dataitem = 1;
function ExpiredNotice(props) {
  const { isUnPublished } = props;

  return (
    <div>
      <Typography
        style={{
          display: 'flex',
          justifyContent: 'space-evenly',
          padding: '20px 0px',
          backgroundColor: 'red',
        }}
      >
        <Typography sx={counterAlignColumProp}>
          {!isUnPublished ? (
            <Typography sx={{ ...poppins600, ...fontsize32 }}>{0}</Typography>
          ) : null}
          <Typography sx={liveDTag}>D</Typography>
        </Typography>
        <Typography sx={counterAlignColumProp}>
          {!isUnPublished ? (
            <Typography sx={{ ...poppins600, ...fontsize32 }}>{0}</Typography>
          ) : null}
          <Typography sx={liveDTag}>H</Typography>
        </Typography>
        <Typography sx={counterAlignColumProp}>
          {!isUnPublished ? (
            <Typography sx={{ ...poppins600, ...fontsize32 }}>{0}</Typography>
          ) : null}
          <Typography sx={liveDTag}>M</Typography>
        </Typography>
        <Typography sx={counterAlignColumProp}>
          {!isUnPublished ? (
            <Typography sx={{ ...poppins600, ...fontsize32 }}>{0}</Typography>
          ) : null}
          <Typography sx={liveDTag}>s</Typography>
        </Typography>
      </Typography>
    </div>
  );
}

const blinkBorder = keyframes`
  0% {
    box-shadow:
      inset 0 -6px 8px rgba(106, 41, 201, 0.25),
      inset 0 0 10px rgba(106, 41, 201, 0.15);
  }

  50% {
    box-shadow:
      inset 0 -6px 8px rgba(106, 41, 201, 0.5),
      inset 0 0 16px rgba(106, 41, 201, 0.35);
  }

  100% {
    box-shadow:
      inset 0 -6px 8px rgba(106, 41, 201, 0.25),
      inset 0 0 10px rgba(106, 41, 201, 0.15);
  }
`;

const blinkBorderOuter = keyframes`
  0% {
    box-shadow:
      0 0 0 2px rgba(106, 41, 201, 0.25),
      0 0 8px rgba(106, 41, 201, 0.25),
      0 0 14px rgba(106, 41, 201, 0.15);
  }

  50% {
    box-shadow:
      0 0 0 2px rgba(106, 41, 201, 0.5),
      0 0 12px rgba(106, 41, 201, 0.5),
      0 0 22px rgba(106, 41, 201, 0.35);
  }

  100% {
    box-shadow:
      0 0 0 2px rgba(106, 41, 201, 0.25),
      0 0 8px rgba(106, 41, 201, 0.25),
      0 0 14px rgba(106, 41, 201, 0.15);
  }
`;

function ShowCounter({
  upperCountDown,
  counterOffer,
  days,
  hours,
  minutes,
  seconds,
  getListInfo,
  isUnPublished,
  propertyId,
  publishcard,
  unpublishcard,
  stage,
  highestOfferId,
  isWinner,
  activityfun,
  setPublish,
  advanced,
  startedAt,
  individual,
  profileDetails,
  propertydata,
  targetDate,
  countDown,
  toresume,
  settoresume,
  starttime,
  setStarttime,
  solidash,
  toend,
  settoend,
  isStickyStageTwo,
  isMakeOfferSm,
  offerStatus,
  isReset,
  ResetTimer,
  hideHeader,
}) {
  let dayslen = String(days).length;
  let hourslen = String(hours).length;
  let minuteslen = String(minutes).length;
  let secondslen = String(seconds).length;
  const parameter = useParams();
  // first confirmation popup state for action table
  const [auctionBox1, setAuctionBox1] = useState(false);
  // Second add auction popup state for action table
  const [auctionBox2, setAuctionBox2] = useState(false);
  const theme = useTheme();
  const matchesmd = useMediaQuery(theme.breakpoints.down('md'));
  const matchessm = useMediaQuery(theme.breakpoints.down('sm'));
  const isNotEmptyArray = (arr) =>
    Array.isArray(arr) &&
    arr.length > 0 &&
    !arr.every((item) => Array.isArray(item) && item.length === 0);

  const moxoapis = (res) => {
    if (isNotEmptyArray(res?.data?.dataForAgentAck))
      Moxoseparationinlisting('dataForAgentAck', res?.data?.dataForAgentAck); //1
    if (isNotEmptyArray(res?.data?.dataForBuyerAck))
      Moxoseparationinlisting('dataForBuyerAck', res?.data?.dataForBuyerAck); //2
    if (isNotEmptyArray(res?.data?.dataForVendorAck))
      Moxoseparationinlisting('dataForVendorAck', res?.data?.dataForVendorAck); //3
  };

  const ColonSm = () => {
    return (
      <svg
        width="5"
        height="18"
        viewBox="0 0 8 28"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M3.808 27.336C2.816 27.336 1.984 27 1.312 26.328C0.64 25.656 0.304 24.824 0.304 23.832C0.304 22.84 0.64 22.008 1.312 21.336C1.984 20.664 2.816 20.328 3.808 20.328C4.768 20.328 5.584 20.664 6.256 21.336C6.928 22.008 7.264 22.84 7.264 23.832C7.264 24.824 6.928 25.656 6.256 26.328C5.584 27 4.768 27.336 3.808 27.336ZM3.808 7.176C2.816 7.176 1.984 6.84 1.312 6.168C0.64 5.496 0.304 4.664 0.304 3.672C0.304 2.68 0.64 1.848 1.312 1.176C1.984 0.503999 2.816 0.167999 3.808 0.167999C4.768 0.167999 5.584 0.503999 6.256 1.176C6.928 1.848 7.264 2.68 7.264 3.672C7.264 4.664 6.928 5.496 6.256 6.168C5.584 6.84 4.768 7.176 3.808 7.176Z"
          fill="black"
        />
      </svg>
    );
  };

  const Colon = (matchessm) => {
    return (
      <svg
        width={matchessm ? '7' : '8'}
        height={matchessm ? '20' : '28'}
        viewBox="0 0 8 28"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M3.808 27.336C2.816 27.336 1.984 27 1.312 26.328C0.64 25.656 0.304 24.824 0.304 23.832C0.304 22.84 0.64 22.008 1.312 21.336C1.984 20.664 2.816 20.328 3.808 20.328C4.768 20.328 5.584 20.664 6.256 21.336C6.928 22.008 7.264 22.84 7.264 23.832C7.264 24.824 6.928 25.656 6.256 26.328C5.584 27 4.768 27.336 3.808 27.336ZM3.808 7.176C2.816 7.176 1.984 6.84 1.312 6.168C0.64 5.496 0.304 4.664 0.304 3.672C0.304 2.68 0.64 1.848 1.312 1.176C1.984 0.503999 2.816 0.167999 3.808 0.167999C4.768 0.167999 5.584 0.503999 6.256 1.176C6.928 1.848 7.264 2.68 7.264 3.672C7.264 4.664 6.928 5.496 6.256 6.168C5.584 6.84 4.768 7.176 3.808 7.176Z"
          fill="black"
        />
      </svg>
    );
  };

  const Warning = () => {
    return (
      <svg
        width="38"
        height="36"
        viewBox="0 0 38 36"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          width="37.5797"
          height="36"
          rx="18"
          fill="#10D35E"
          fill-opacity="0.1"
        />
        <path
          d="M27.0817 21.4607L21.3085 11.456C20.7883 10.5551 19.8271 10 18.7866 10C17.7462 10 16.7851 10.5551 16.2648 11.456L10.3902 21.632C9.86994 22.5329 9.86994 23.6431 10.3902 24.544C10.9104 25.4449 11.8715 26 12.912 26H24.6614C24.6646 26 24.6677 26 24.6677 26C26.276 26 27.5797 24.6962 27.5797 23.088C27.5797 22.4853 27.3957 21.9239 27.0817 21.4607ZM20.0333 22.4345C20.0333 23.1229 19.5036 23.6495 18.7898 23.6495C18.0761 23.6495 17.5464 23.1229 17.5464 22.4345V22.406C17.5464 21.7208 18.0761 21.1911 18.7898 21.1911C19.5036 21.1911 20.0333 21.7177 20.0333 22.406V22.4345ZM20.0619 14.2443L19.4465 19.6178C19.4052 20.0048 19.1483 20.2458 18.7898 20.2458C18.4314 20.2458 18.1745 20.0016 18.1332 19.6178L17.5178 14.2411C17.4766 13.8255 17.7019 13.5115 18.0888 13.5115H19.4877C19.8747 13.5147 20.1031 13.8287 20.0619 14.2443Z"
          fill="#10D35E"
        />
      </svg>
    );
  };

  const [localReset, setLocalReset] = useState(false);

  useEffect(() => {
    if (isReset) {
      setLocalReset(true);

      const timer = setTimeout(() => {
        ResetTimer();
        // activityfun?.();
        setLocalReset(false);
      }, 5500);

      return () => clearTimeout(timer);
    }
  }, [isReset]);

  const currentPage = window.location.pathname;

  return (
    <div>
      {(((currentPage.includes('/market') || currentPage.includes('/share')) &&
        !upperCountDown) ||
        currentPage.includes('/People') ||
        currentPage.includes('/landingpage') ||
        currentPage.includes('/dashboard') ||
        currentPage.includes('/BuyerDashboard') ||
        currentPage.includes('/VendorDashboard') ||
        currentPage.includes('/VendorIndividualDashboard') ||
        currentPage.includes('/VendorInactiveIndividual') ||
        currentPage.includes('/insights') ||
        currentPage.includes('/message') ||
        currentPage.includes('/tasks') ||
        currentPage.includes('/solicitor') ||
        currentPage.includes('/notification')) && (
        <>
          {String(days).includes('-') ||
          (isNaN(days) && String(hours).includes('-')) ||
          (isNaN(hours) && String(minutes).includes('-')) ||
          (isNaN(minutes) && String(seconds).includes('-')) ||
          (isNaN(seconds) && !unpublishcard) ? (
            <Typography
              sx={{
                display: 'flex',
                flexDirection: 'column',
                marginTop: currentPage.includes('/market') && '20px',
              }}
            >
              <Typography
                sx={{
                  fontFamily: 'poppins',
                  fontWeight: 500,
                  fontSize: hideHeader ? '20px' : '32px',
                  textAlign: 'center',
                }}
              >
                E n d e d
              </Typography>
              {!hideHeader && (
                <Typography
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: currentPage.includes('/view-dashboard')
                      ? '15px'
                      : currentPage.includes('/People')
                      ? '15px'
                      : '40px',
                  }}
                >
                  <Typography sx={liveDTag}>D</Typography>
                  <Typography sx={liveDTag}>H</Typography>
                  <Typography sx={liveDTag}>M</Typography>
                  <Typography sx={liveDTag}>S</Typography>
                </Typography>
              )}
            </Typography>
          ) : (
            <Typography
              style={{
                display: 'flex',
                justifyContent: 'center',
                borderRadius:
                  (currentPage.includes('/market') ||
                    currentPage.includes('/share')) &&
                  '10px',
                gap: '5px',
                padding: currentPage.includes('/solicitor')
                  ? '0px'
                  : '0px 30px',
                marginTop:
                  (currentPage.includes('/market') ||
                    currentPage.includes('/share')) &&
                  '25px',
                width: currentPage.includes('/solicitor') && '150px',
              }}
              sx={{
                boxShadow:
                  currentPage.includes('/market') && isReset ? 'none' : 'none',
                animation:
                  currentPage.includes('/market') && localReset
                    ? `${blinkBorderOuter} 1s ease-in-out infinite`
                    : 'none',
              }}
            >
              <Typography sx={counterAlignColumProp}>
                <Typography
                  sx={{
                    ...poppins600,
                    fontSize: hideHeader
                      ? '14px'
                      : solidash
                      ? '20px'
                      : advanced
                      ? '20px'
                      : '32px',
                    whiteSpace: 'nowrap',
                  }}
                >
                  {String(days).includes('-') || isNaN(days) ? (
                    '00 :'
                  ) : (
                    <Typography
                      sx={{
                        ...poppins600,
                        color:
                          counterOffer === null &&
                          (offerStatus == 'Counter Received' ||
                            offerStatus == 'Private Offer') &&
                          stage == 'ST1' &&
                          'white',
                        fontSize: hideHeader
                          ? '14px'
                          : solidash
                          ? '20px'
                          : advanced
                          ? '20px'
                          : '32px',
                        whiteSpace: 'nowrap',
                      }}
                    >
                      {dayslen == 1 ? '0' : null}
                      {dayslen == 0 ? '00' : null}
                      {days} :
                    </Typography>
                  )}
                </Typography>
                {!hideHeader && (
                  <Typography
                    sx={
                      counterOffer === null &&
                      (offerStatus == 'Counter Received' ||
                        offerStatus == 'Private Offer') &&
                      stage == 'ST1'
                        ? counterLiveDTag
                        : liveDTag
                    }
                  >
                    D
                  </Typography>
                )}
              </Typography>
              <Typography sx={counterAlignColumProp}>
                <Typography
                  sx={{
                    ...poppins600,
                    fontSize: hideHeader
                      ? '14px'
                      : solidash
                      ? '20px'
                      : advanced
                      ? '20px'
                      : '32px',
                    whiteSpace: 'nowrap',
                  }}
                >
                  {String(hours).includes('-') || isNaN(hours) ? (
                    '00 :'
                  ) : (
                    <Typography
                      sx={{
                        ...poppins600,
                        color:
                          counterOffer === null &&
                          (offerStatus == 'Counter Received' ||
                            offerStatus == 'Private Offer') &&
                          stage == 'ST1' &&
                          'white',
                        fontSize: hideHeader
                          ? '14px'
                          : solidash
                          ? '20px'
                          : advanced
                          ? '20px'
                          : '32px',
                        whiteSpace: 'nowrap',
                      }}
                    >
                      {hourslen == 1 ? '0' : null}
                      {hourslen == 0 ? '00' : null}
                      {hours} :
                    </Typography>
                  )}
                </Typography>
                {!hideHeader && (
                  <Typography
                    sx={
                      counterOffer === null &&
                      (offerStatus == 'Counter Received' ||
                        offerStatus == 'Private Offer') &&
                      stage == 'ST1'
                        ? counterLiveDTag
                        : liveDTag
                    }
                  >
                    H
                  </Typography>
                )}
              </Typography>
              <Typography sx={counterAlignColumProp}>
                <Typography
                  sx={{
                    ...poppins600,
                    fontSize: hideHeader
                      ? '14px'
                      : solidash
                      ? '20px'
                      : advanced
                      ? '20px'
                      : '32px',
                    whiteSpace: 'nowrap',
                  }}
                >
                  {String(minutes).includes('-') || isNaN(minutes) ? (
                    '00 :'
                  ) : (
                    <Typography
                      sx={{
                        ...poppins600,
                        color:
                          counterOffer === null &&
                          (offerStatus == 'Counter Received' ||
                            offerStatus == 'Private Offer') &&
                          stage == 'ST1' &&
                          'white',
                        fontSize: hideHeader
                          ? '14px'
                          : solidash
                          ? '20px'
                          : advanced
                          ? '20px'
                          : '32px',
                        whiteSpace: 'nowrap',
                      }}
                    >
                      {minuteslen == 1 ? '0' : null}
                      {minuteslen == 0 ? '00' : null}
                      {minutes} :
                    </Typography>
                  )}
                </Typography>
                {!hideHeader && (
                  <Typography
                    sx={
                      counterOffer === null &&
                      (offerStatus == 'Counter Received' ||
                        offerStatus == 'Private Offer') &&
                      stage == 'ST1'
                        ? counterLiveDTag
                        : liveDTag
                    }
                  >
                    M
                  </Typography>
                )}
              </Typography>
              <Typography sx={counterAlignColumProp}>
                <Typography
                  sx={{
                    ...poppins600,
                    fontSize: hideHeader
                      ? '14px'
                      : solidash
                      ? '20px'
                      : advanced
                      ? '20px'
                      : '32px',
                    whiteSpace: 'nowrap',
                  }}
                >
                  {String(seconds).includes('-') || isNaN(seconds) ? (
                    '00'
                  ) : (
                    <Typography
                      sx={{
                        ...poppins600,
                        color:
                          counterOffer === null &&
                          (offerStatus == 'Counter Received' ||
                            offerStatus == 'Private Offer') &&
                          stage == 'ST1' &&
                          'white',
                        fontSize: hideHeader
                          ? '14px'
                          : solidash
                          ? '20px'
                          : advanced
                          ? '20px'
                          : '32px',
                        whiteSpace: 'nowrap',
                      }}
                    >
                      {secondslen == 1 ? '0' : null}
                      {secondslen == 0 ? '00' : null}
                      {seconds}
                    </Typography>
                  )}
                </Typography>
                {!hideHeader && (
                  <Typography
                    sx={
                      counterOffer === null &&
                      (offerStatus == 'Counter Received' ||
                        offerStatus == 'Private Offer') &&
                      stage == 'ST1'
                        ? counterLiveDTag
                        : liveDTag
                    }
                  >
                    S
                  </Typography>
                )}
              </Typography>
            </Typography>
          )}
        </>
      )}

      {(currentPage.includes('/share') || currentPage.includes('/market')) &&
        upperCountDown &&
        !isStickyStageTwo &&
        !isMakeOfferSm && (
          <>
            <Grid
              sx={{
                height: '60%',
                display: 'flex',
                justifyContent: 'space-between',
              }}
            >
              <Card
                sx={{
                  width: matchessm ? '60px' : '65px',
                  height: matchessm ? '55px' : '65px',
                  background: '#FFFFFF',
                  // boxShadow: '0px 1px 6px rgba(0, 0, 0, 0.15)',
                  borderRadius: '8px',
                  textAlign: 'center',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  display: 'flex',

                  boxShadow:
                    currentPage.includes('/market') && isReset
                      ? 'none'
                      : '0px 1px 6px rgba(0, 0, 0, 0.15)',
                  animation:
                    currentPage.includes('/market') && localReset
                      ? `${blinkBorder} 1s ease-in-out infinite`
                      : 'none',

                  // marginBottom: "100px",
                  // marginLeft: "101px",
                }}
              >
                <Stack>
                  {String(days).includes('-') || isNaN(days) ? (
                    <Typography
                      sx={{
                        fontSize: matchessm ? '16px' : '20px',
                        ...poppins600,
                      }}
                    >
                      00
                    </Typography>
                  ) : (
                    <Typography
                      sx={{
                        ...poppins600,
                        fontSize: matchessm ? '16px' : '20px',
                        color: '#6C2AD2',
                        lineHeight: '30px',
                      }}
                    >
                      {dayslen == 1 ? '0' : null}
                      {dayslen == 0 ? '00' : null}
                      {days}
                    </Typography>
                  )}
                </Stack>
                <Stack>
                  <Typography
                    sx={{
                      fontFamily: 'Poppins !important',
                      fontStyle: 'normal !important',
                      fontWeight: '400 !important',
                      fontSize: matchessm ? '12px' : '14px',
                      color: '#666666',
                    }}
                  >
                    Days
                  </Typography>
                </Stack>
              </Card>
              <Stack sx={{ justifyContent: 'center' }}>
                <Colon matchessm={matchessm} />
              </Stack>
              <Card
                sx={{
                  width: matchessm ? '60px' : '65px',
                  height: matchessm ? '55px' : '65px',
                  background: '#FFFFFF',
                  // boxShadow: '0px 1px 6px rgba(0, 0, 0, 0.15)',
                  borderRadius: '8px',
                  textAlign: 'center',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  display: 'flex',

                  boxShadow:
                    currentPage.includes('/market') && isReset
                      ? 'none'
                      : '0px 1px 6px rgba(0, 0, 0, 0.15)',
                  animation:
                    currentPage.includes('/market') && localReset
                      ? `${blinkBorder} 1s ease-in-out infinite`
                      : 'none',
                  // marginLeft: "13px",
                }}
              >
                <Stack>
                  {String(hours).includes('-') || isNaN(hours) ? (
                    <Typography
                      sx={{
                        ...poppins600,
                        fontSize: matchessm ? '16px' : '20px',
                      }}
                    >
                      00
                    </Typography>
                  ) : (
                    <Typography
                      sx={{
                        ...poppins600,
                        fontSize: matchessm ? '16px' : '20px',
                        color: '#6C2AD2',
                        lineHeight: '30px',
                      }}
                    >
                      {hourslen == 1 ? '0' : null}
                      {hourslen == 0 ? '00' : null}
                      {hours}
                    </Typography>
                  )}
                </Stack>
                <Stack>
                  <Typography
                    sx={{
                      fontFamily: 'Poppins !important',
                      fontStyle: 'normal !important',
                      fontWeight: '400 !important',
                      fontSize: matchessm ? '12px' : '14px',
                      color: '#666666',
                    }}
                  >
                    Hours
                  </Typography>
                </Stack>
              </Card>
              <Stack sx={{ justifyContent: 'center' }}>
                <Colon />
              </Stack>
              <Card
                sx={{
                  width: matchessm ? '60px' : '65px',
                  height: matchessm ? '55px' : '65px',
                  background: '#FFFFFF',
                  // boxShadow: '0px 1px 6px rgba(0, 0, 0, 0.15)',
                  borderRadius: '8px',
                  textAlign: 'center',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  display: 'flex',

                  boxShadow:
                    currentPage.includes('/market') && isReset
                      ? 'none'
                      : '0px 1px 6px rgba(0, 0, 0, 0.15)',
                  animation:
                    currentPage.includes('/market') && localReset
                      ? `${blinkBorder} 1s ease-in-out infinite`
                      : 'none',

                  // marginLeft: "13px",
                }}
              >
                <Stack>
                  {String(minutes).includes('-') || isNaN(minutes) ? (
                    <Typography
                      sx={{
                        ...poppins600,
                        fontSize: matchessm ? '16px' : '20px',
                      }}
                    >
                      00
                    </Typography>
                  ) : (
                    <Typography
                      sx={{
                        ...poppins600,
                        fontSize: matchessm ? '16px' : '20px',
                        color: '#6C2AD2',
                        lineHeight: '30px',
                      }}
                    >
                      {minuteslen == 1 ? '0' : null}
                      {minuteslen == 0 ? '00' : null}
                      {minutes}
                    </Typography>
                  )}
                </Stack>
                <Stack sx={{ justifyContent: 'center' }}>
                  <Typography
                    sx={{
                      fontFamily: 'Poppins !important',
                      fontStyle: 'normal !important',
                      fontWeight: '400 !important',
                      fontSize: matchessm ? '12px' : '14px',
                      color: '#666666',
                    }}
                  >
                    Minutes
                  </Typography>
                </Stack>
              </Card>
              <Stack sx={{ justifyContent: 'center' }}>
                <Colon />
              </Stack>
              <Card
                sx={{
                  textAlign: 'center',
                  width: matchessm ? '60px' : '65px',
                  height: matchessm ? '55px' : '65px',
                  background: '#FFFFFF',
                  // boxShadow: '0px 1px 6px rgba(0, 0, 0, 0.15)',
                  borderRadius: '8px',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  display: 'flex',

                  boxShadow:
                    currentPage.includes('/market') && isReset
                      ? 'none'
                      : '0px 1px 6px rgba(0, 0, 0, 0.15)',
                  animation:
                    currentPage.includes('/market') && localReset
                      ? `${blinkBorder} 1s ease-in-out infinite`
                      : 'none',
                  // marginTop: "63px",
                  // marginLeft: "13px",
                }}
              >
                <Stack>
                  {String(seconds).includes('-') || isNaN(seconds) ? (
                    <Typography
                      sx={{
                        ...poppins600,
                        fontSize: matchessm ? '16px' : '20px',
                      }}
                    >
                      00
                    </Typography>
                  ) : (
                    <Typography
                      sx={{
                        ...poppins600,
                        fontSize: matchessm ? '16px' : '20px',
                        color: '#6C2AD2',
                        lineHeight: '30px',
                      }}
                    >
                      {secondslen == 1 ? '0' : null}
                      {secondslen == 0 ? '00' : null}
                      {seconds}
                    </Typography>
                  )}
                </Stack>
                <Stack>
                  <Typography
                    sx={{
                      fontFamily: 'Poppins !important',
                      fontStyle: 'normal !important',
                      fontWeight: '400 !important',
                      fontSize: matchessm ? '12px' : '14px',
                      color: '#666666',
                    }}
                  >
                    Seconds
                  </Typography>
                </Stack>
              </Card>
            </Grid>
          </>
        )}
      {/* Staget two sticky timer on buyer individual */}
      {(!currentPage.includes('/share') || currentPage.includes('/market')) &&
        upperCountDown &&
        !isMakeOfferSm &&
        isStickyStageTwo && (
          <Stack
            direction={'row'}
            alignItems={'center'}
            sx={{ marginTop: '-6px' }}
            spacing={1}
          >
            <Typography sx={{ width: '20px' }}>
              {String(hours).includes('-') || isNaN(hours) ? (
                <Typography
                  sx={{
                    ...poppins400,
                    fontSize: '18px',
                    color: '#FFFFFF',
                    maxWidth: '3px',
                  }}
                >
                  00
                </Typography>
              ) : (
                <Typography
                  sx={{
                    ...poppins400,
                    fontSize: '18px',
                    color: '#FFFFFF',
                    maxWidth: '3px',
                  }}
                >
                  {hourslen == 1 ? '0' : null}
                  {hourslen == 0 ? '00' : null}
                  {hours}
                </Typography>
              )}
            </Typography>
            <Typography
              sx={{
                fontFamily: 'Poppins !important',
                fontWeight: 400,
                fontSize: '18px',
                color: '#FFFFFF',
              }}
            >
              Hours
            </Typography>
            &nbsp;:
            <Typography sx={{ width: '20px' }}>
              {String(minutes).includes('-') || isNaN(minutes) ? (
                <Typography
                  sx={{
                    ...poppins400,
                    fontSize: '18px',
                    color: '#FFFFFF',
                    maxWidth: '3px',
                  }}
                >
                  00
                </Typography>
              ) : (
                <Typography
                  sx={{
                    ...poppins400,
                    fontSize: '18px',
                    color: '#FFFFFF',
                  }}
                >
                  {minuteslen == 1 ? '0' : null}
                  {minuteslen == 0 ? '00' : null}
                  {minutes}
                </Typography>
              )}
            </Typography>
            <Typography
              sx={{
                fontFamily: 'Poppins !important',
                fontWeight: 400,
                fontSize: '18px',
                color: '#FFFFFF',
              }}
            >
              Minutes
            </Typography>
            &nbsp;:
            <Typography sx={{ width: '20px' }}>
              {String(seconds).includes('-') || isNaN(seconds) ? (
                <Typography
                  sx={{
                    ...poppins400,
                    fontSize: '18px',
                    color: '#FFFFFF',
                    maxWidth: '3px',
                  }}
                >
                  00
                </Typography>
              ) : (
                <Typography
                  sx={{
                    ...poppins400,
                    fontSize: '18px',
                    color: '#FFFFFF',
                  }}
                >
                  {secondslen == 1 ? '0' : null}
                  {secondslen == 0 ? '00' : null}
                  {seconds}
                </Typography>
              )}
            </Typography>
            <Typography
              sx={{
                fontFamily: 'Poppins !important',
                fontWeight: 400,
                fontSize: '18px',
                color: '#FFFFFF',
              }}
            >
              Seconds
            </Typography>
          </Stack>
        )}
      {/* Mobile view make offer top sticky Timer */}
      {(!currentPage.includes('/share') || currentPage.includes('/market')) &&
        // upperCountDown &&
        isMakeOfferSm && (
          <Stack
            direction={'row'}
            alignItems={'center'}
            // sx={{ marginTop: "21px" }}
            spacing={0.5}
            color={'#FFFFFF'}
            fontSize={'12px'}
          >
            <Typography sx={{ width: '20px' }}>
              {String(days).includes('-') || isNaN(days) ? (
                <Typography sx={{ ...poppins400, fontSize: '12px' }}>
                  00
                </Typography>
              ) : (
                <Typography
                  sx={{
                    ...poppins600,
                    fontSize: '12px',
                    color: '#FFFFFF',
                  }}
                >
                  {dayslen == 1 ? '0' : null}
                  {dayslen == 0 ? '00' : null}
                  {days}
                </Typography>
              )}
            </Typography>
            <Typography style={{ marginTop: '1px' }}>
              <Typography
                sx={{
                  fontFamily: 'Poppins !important',
                  fontWeight: 600,
                  fontSize: '12px',
                  color: '#FFFFFF',
                }}
              >
                days
              </Typography>
            </Typography>
            &nbsp;:
            <Typography sx={{ width: '20px' }}>
              {String(hours).includes('-') || isNaN(hours) ? (
                <Typography sx={{ ...poppins400, fontSize: '12px' }}>
                  00
                </Typography>
              ) : (
                <Typography
                  sx={{
                    ...poppins600,
                    fontSize: '12px',
                    color: '#FFFFFF',
                    maxWidth: '3px',
                  }}
                >
                  {hourslen == 1 ? '0' : null}
                  {hourslen == 0 ? '00' : null}
                  {hours}
                </Typography>
              )}
            </Typography>
            <Typography style={{ marginTop: '1px' }}>
              <Typography
                sx={{
                  fontFamily: 'Poppins !important',
                  fontWeight: 600,
                  fontSize: '12px',
                  color: '#FFFFFF',
                }}
              >
                hours
              </Typography>
            </Typography>
            &nbsp;:
            <Typography sx={{ width: '20px' }}>
              {String(minutes).includes('-') || isNaN(minutes) ? (
                <Typography sx={{ ...poppins400, fontSize: '12px' }}>
                  00
                </Typography>
              ) : (
                <Typography
                  sx={{
                    ...poppins600,
                    fontSize: '12px',
                    color: '#FFFFFF',
                  }}
                >
                  {minuteslen == 1 ? '0' : null}
                  {minuteslen == 0 ? '00' : null}
                  {minutes}
                </Typography>
              )}
            </Typography>
            <Typography style={{ marginTop: '1px' }}>
              <Typography
                sx={{
                  fontFamily: 'Poppins !important',
                  fontWeight: 600,
                  fontSize: '12px',
                  color: '#FFFFFF',
                }}
              >
                minutes
              </Typography>
            </Typography>
            &nbsp;:
            <Typography sx={{ width: '20px' }}>
              {String(seconds).includes('-') || isNaN(seconds) ? (
                <Typography sx={{ ...poppins400, fontSize: '12px' }}>
                  00
                </Typography>
              ) : (
                <Typography
                  sx={{
                    ...poppins600,
                    fontSize: '12px',
                    color: '#FFFFFF',
                  }}
                >
                  {secondslen == 1 ? '0' : null}
                  {secondslen == 0 ? '00' : null}
                  {seconds}
                </Typography>
              )}
            </Typography>
            <Typography style={{ marginTop: '1px' }}>
              <Typography
                sx={{
                  fontFamily: 'Poppins !important',
                  fontWeight: 600,
                  fontSize: '12px',
                  color: '#FFFFFF',
                }}
              >
                secs
              </Typography>
            </Typography>
          </Stack>
        )}

      {currentPage.includes('/Savedsearch') && (
        <>
          <Grid
            sx={{
              height: '60%',
              display: 'flex',
              justifyContent: matchessm ? 'start' : 'space-between',
              gap: matchessm ? '5px' : '',
              // paddingTop:"10px",
            }}
          >
            <Card
              sx={{
                width: matchessm ? '40px' : '65px',
                height: matchessm ? '40px' : '65px',
                background: '#FFFFFF',
                boxShadow: '0px 1px 6px rgba(0, 0, 0, 0.15)',
                borderRadius: '8px',
                textAlign: 'center',
                flexDirection: 'column',
                justifyContent: 'center',
                display: 'flex',
                // marginBottom: "100px",
                // marginLeft: "101px",
              }}
            >
              <Stack>
                {String(days).includes('-') || isNaN(days) ? (
                  <Typography
                    sx={{
                      ...poppins600,
                      fontSize: matchessm ? '16px' : '32px',
                    }}
                  >
                    00
                  </Typography>
                ) : (
                  <Typography
                    sx={{
                      ...poppins600,
                      fontSize: '20px',
                      color: '#6C2AD2',
                      lineHeight: '30px',
                    }}
                  >
                    {dayslen == 1 ? '0' : null}
                    {dayslen == 0 ? '00' : null}
                    {days}
                  </Typography>
                )}
              </Stack>
              <Stack>
                <Typography
                  sx={{
                    fontFamily: 'Poppins !important',
                    fontStyle: 'normal !important',
                    fontWeight: '400 !important',
                    fontSize: matchessm ? '9px' : '14px',
                    color: '#666666',
                  }}
                >
                  Days
                </Typography>
              </Stack>
            </Card>
            <Stack sx={{ justifyContent: 'center' }}>
              {matchessm ? <ColonSm /> : <Colon />}
            </Stack>
            <Card
              sx={{
                width: matchessm ? '40px' : '65px',
                height: matchessm ? '40px' : '65px',
                background: '#FFFFFF',
                boxShadow: '0px 1px 6px rgba(0, 0, 0, 0.15)',
                borderRadius: '8px',
                textAlign: 'center',
                flexDirection: 'column',
                justifyContent: 'center',
                display: 'flex',
              }}
            >
              <Stack>
                {String(hours).includes('-') || isNaN(hours) ? (
                  <Typography
                    sx={{
                      ...poppins600,
                      fontSize: matchessm ? '16px' : '32px',
                    }}
                  >
                    00
                  </Typography>
                ) : (
                  <Typography
                    sx={{
                      ...poppins600,
                      fontSize: '20px',
                      color: '#6C2AD2',
                      lineHeight: '30px',
                    }}
                  >
                    {hourslen == 1 ? '0' : null}
                    {hourslen == 0 ? '00' : null}
                    {hours}
                  </Typography>
                )}
              </Stack>
              <Stack>
                <Typography
                  sx={{
                    fontFamily: 'Poppins !important',
                    fontStyle: 'normal !important',
                    fontWeight: '400 !important',
                    fontSize: matchessm ? '9px' : '14px',
                    color: '#666666',
                  }}
                >
                  Hours
                </Typography>
              </Stack>
            </Card>
            <Stack sx={{ justifyContent: 'center' }}>
              {matchessm ? <ColonSm /> : <Colon />}
            </Stack>
            <Card
              sx={{
                width: matchessm ? '40px' : '65px',
                height: matchessm ? '40px' : '65px',
                background: '#FFFFFF',
                boxShadow: '0px 1px 6px rgba(0, 0, 0, 0.15)',
                borderRadius: '8px',
                textAlign: 'center',
                flexDirection: 'column',
                justifyContent: 'center',
                display: 'flex',
                // marginLeft: "13px",
              }}
            >
              <Stack>
                {String(minutes).includes('-') || isNaN(minutes) ? (
                  <Typography
                    sx={{
                      ...poppins600,
                      fontSize: matchessm ? '16px' : '32px',
                    }}
                  >
                    00
                  </Typography>
                ) : (
                  <Typography
                    sx={{
                      ...poppins600,
                      fontSize: '20px',
                      color: '#6C2AD2',
                      lineHeight: '30px',
                    }}
                  >
                    {minuteslen == 1 ? '0' : null}
                    {minuteslen == 0 ? '00' : null}
                    {minutes}
                  </Typography>
                )}
              </Stack>
              <Stack sx={{ justifyContent: 'center' }}>
                <Typography
                  sx={{
                    fontFamily: 'Poppins !important',
                    fontStyle: 'normal !important',
                    fontWeight: '400 !important',
                    fontSize: matchessm ? '9px' : '14px',
                    color: '#666666',
                  }}
                >
                  Minutes
                </Typography>
              </Stack>
            </Card>
            <Stack sx={{ justifyContent: 'center' }}>
              {matchessm ? <ColonSm /> : <Colon />}
            </Stack>
            <Card
              sx={{
                textAlign: 'center',
                width: matchessm ? '40px' : '65px',
                height: matchessm ? '40px' : '65px',
                background: '#FFFFFF',
                boxShadow: '0px 1px 6px rgba(0, 0, 0, 0.15)',
                borderRadius: '8px',
                flexDirection: 'column',
                justifyContent: 'center',
                display: 'flex',
                // marginTop: "63px",
                // marginLeft: "13px",
              }}
            >
              <Stack>
                {String(seconds).includes('-') || isNaN(seconds) ? (
                  <Typography
                    sx={{
                      ...poppins600,
                      fontSize: matchessm ? '16px' : '32px',
                    }}
                  >
                    00
                  </Typography>
                ) : (
                  <Typography
                    sx={{
                      ...poppins600,
                      fontSize: '20px',
                      color: '#6C2AD2',
                      lineHeight: '30px',
                    }}
                  >
                    {secondslen == 1 ? '0' : null}
                    {secondslen == 0 ? '00' : null}
                    {seconds}
                  </Typography>
                )}
              </Stack>
              <Stack>
                <Typography
                  sx={{
                    fontFamily: 'Poppins !important',
                    fontStyle: 'normal !important',
                    fontWeight: '400 !important',
                    fontSize: matchessm ? '9px' : '14px',
                    color: '#666666',
                  }}
                >
                  Seconds
                </Typography>
              </Stack>
            </Card>
          </Grid>
        </>
      )}
      {/* acution table first confirmation dialog  */}

      <AuctionDialogOne
        open={auctionBox1}
        onClose={() => setAuctionBox1(false)}
        onConfirm={() => {
          setAuctionBox1(false);
          setAuctionBox2(true); // or handle other logic
        }}
        profileDetails={profileDetails}
      />

      {/* auction table add action dialog  */}
      <AuctionDialogTwo
        open={auctionBox2}
        onClose={() => setAuctionBox2(false)}
        profileDetails={profileDetails}
        setAuctionBox2={setAuctionBox2}
      />
    </div>
  );
}

function CountdownTimer({
  upperCountDown,
  counterOffer,
  targetDate,
  getListInfo,
  isRunning = true,
  propertyId,
  isUnPublished,
  publishcard,
  unpublishcard,
  paused,
  pausestatus,
  stage,
  highestOfferId,
  isWinner,
  activityfun,
  setPublish,
  advanced,
  startedAt,
  individual,
  profileDetails,
  propertydata,
  solidash,
  isStickyStageTwo,
  isMakeOfferSm,
  offerStatus,
  isReset,
  ResetTimer,
  hideHeader,
}) {
  var [days, hours, minutes, seconds, countDown] = UseCountdown(
    targetDate,
    true,
    isUnPublished
  );

  // if (isUnPublished) {
  //   return <ExpiredNotice />;
  // }
  if (pausestatus) {
    const totalSeconds = Math.floor(paused / 1000);
    const totalMinutes = Math.floor(totalSeconds / 60);
    const totalHours = Math.floor(totalMinutes / 60);
    const totalDays = Math.floor(totalHours / 24);

    const remainingSeconds = totalSeconds % 60;
    const remainingMinutes = totalMinutes % 60;
    const remainingHours = totalHours % 24;
    const remainingDays = totalDays;
    const duration = moment.duration(paused, 'milliseconds');

    var pauseddays = remainingDays;

    var pausedhours = remainingHours;

    var pausedminutes = remainingMinutes;

    var pausedseconds = remainingSeconds;
  }

  const [toresume, settoresume] = useState(false);
  const [starttime, setStarttime] = useState(false);
  const [toend, settoend] = useState(false);
  return (
    <ShowCounter
      days={pausestatus ? pauseddays : days}
      hours={pausestatus ? pausedhours : hours}
      minutes={pausestatus ? pausedminutes : minutes}
      seconds={pausestatus ? pausedseconds : seconds}
      propertyId={propertyId}
      isUnPublished={isUnPublished}
      publishcard={publishcard}
      unpublishcard={unpublishcard}
      getListInfo={getListInfo}
      upperCountDown={upperCountDown}
      stage={stage}
      highestOfferId={highestOfferId}
      isWinner={isWinner}
      activityfun={activityfun}
      setPublish={setPublish}
      advanced={advanced}
      startedAt={startedAt}
      individual={individual}
      profileDetails={profileDetails}
      propertydata={propertydata}
      targetDate={targetDate}
      countDown={countDown}
      toresume={toresume}
      settoresume={settoresume}
      starttime={starttime}
      setStarttime={setStarttime}
      solidash={solidash}
      toend={toend}
      settoend={settoend}
      counterOffer={counterOffer}
      offerStatus={offerStatus}
      isStickyStageTwo={isStickyStageTwo}
      isMakeOfferSm={isMakeOfferSm}
      isReset={isReset}
      ResetTimer={ResetTimer}
      hideHeader={hideHeader}
    />
  );
}

export default CountdownTimer;
